import { render, staticRenderFns } from "./HomeBlockText.vue?vue&type=template&id=4798de7b&scoped=true&name=home-block-text&"
import script from "./HomeBlockText.vue?vue&type=script&lang=js&"
export * from "./HomeBlockText.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlockText.vue?vue&type=style&index=0&id=4798de7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798de7b",
  null
  
)

export default component.exports